// extracted by mini-css-extract-plugin
export default {"error":"ConfirmEmail_error__Mbdmz","center":"ConfirmEmail_center__--lOu","support":"ConfirmEmail_support__68FeV"};